import { EventEmitter, Type } from '@angular/core';
// Using <T> generic for specifiying the tabData type
export class Tab<T> {
    public id: number = 1;
    public title: string;
    public tabData: T | undefined;
    public active: boolean;
    public tabType : string = ""; 
    public component: Type<any>;
  
    constructor(component: Type<any>, title: string, tabType : string, tabData?: T) {
      this.tabData = tabData ? tabData : undefined;
      this.component = component;
      this.active = false;
      this.title = title;
      this.tabType = tabType;
    }
  }